import React, { useContext, useEffect, useState } from 'react'
import { AppContext } from '../../context/app'
import QRCode from 'react-qr-code'
import RoundCrossIcon from '../../assets/imgComponents/roundCrossIcon'
import { isEmpty } from '../../utils/helper'
import useTemplateHook from '../template/templateHook'

const TipJarModal = () => {
  const { getLinkUrl } = useTemplateHook()
  const { tipJarModalConfig, setTipJarModalConfig } = useContext(AppContext)
  const [currentSelectedChild, setCurrentSelectedChild] = useState({})

  useEffect(() => {
    if (!isEmpty(tipJarModalConfig) && tipJarModalConfig?.allow_multiple_links) {
      setCurrentSelectedChild(tipJarModalConfig.child_buttons[0])
    }
  }, [tipJarModalConfig])

  return (
    <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none h-full  ">
      {/* <div style={{}} className={`relative w-screen lg:w-[40vw] xl:w-[90rem]`}> */}
      <div style={{}} className={`relative `}>
        <div
          style={{
            backgroundImage: 'linear-gradient(to bottom, #2f3b4a, #132843)',
            fontFamily: 'Arial',
            border: 'solid 1px #707070',
            borderRadius: '6px',
          }}
          className="shadow-lg relative flex flex-col w-full py-10"
        >
          <div className=" ">
            <div
              className=" absolute right-0 top-0 z-20 m-4"
              onClick={() => {
                setTipJarModalConfig({})
              }}
            >
              <RoundCrossIcon color="#fff" className="h-5 cursor-pointer float-right w-5 " />
            </div>

            <div className="flex flex-col md:flex-row justify-center items-center relative my-4 px-6 xl:px-[60px]">
              <div
                className={`${
                  tipJarModalConfig.allow_multiple_links && 'md:mr-[30px] xl:mr-[90px]'
                } `}
              >
                {tipJarModalConfig.allow_multiple_links && !isEmpty(tipJarModalConfig.child_buttons)
                  ? tipJarModalConfig.child_buttons
                      .filter((i) => i.name)
                      .map((info, index) => {
                        return (
                          <div
                            style={{ minWidth: '235px' }}
                            className="w-full text-xs md:text-lg"
                            onClick={() => setCurrentSelectedChild(info)}
                            key={index}
                          >
                            <div
                              style={{
                                color: info.name === currentSelectedChild.name ? '#09e9e9' : '#fff',
                              }}
                              className={`${
                                info.name === currentSelectedChild.name &&
                                'bg-transparent md:bg-[#212c3a] md:border-[#09e9e9]'
                              } h-6 md:h-[44px] px-2 md:font-semibold flex items-center justify-center md:justify-start cursor-pointer border-b md:border-b-0 md:border-r border-[#ffffff80]  `}
                            >
                              {info.name}
                            </div>
                          </div>
                        )
                      })
                  : null}
              </div>

              <div className="p-4 rounded-lg  mt-4 md:mt-0" style={{ background: '#00000060' }}>
                <p className=" w-full text-center text-xs xl:text-lg mb-6 text-white">
                  PLEASE SCAN TO DONATE
                </p>
                <QRCode
                  value={`${getLinkUrl(
                    isEmpty(currentSelectedChild)
                      ? tipJarModalConfig.link
                      : currentSelectedChild.link,
                  )}`}
                />
                <div className=" flex justify-between items-center w-full mt-4 text-white">
                  <div style={{ width: '40%', border: '0.25px solid #70707070' }} />
                  <p style={{ width: '10%' }}>OR</p>
                  <div style={{ width: '40%', border: '0.25px solid #70707070' }} />
                </div>
                <div className="flex justify-center items-center w-full relative mt-4 ">
                  <button
                    className="px-4 py-2 w-full rounded-full font-bold"
                    style={{
                      color: '#fff',
                      backgroundImage: 'linear-gradient(87deg, #00fbea, #6d00bf)',
                    }}
                    onClick={() => {
                      tipJarModalConfig?.activatePipMode()
                      window.open(
                        `${getLinkUrl(
                          isEmpty(currentSelectedChild)
                            ? tipJarModalConfig.link
                            : currentSelectedChild.link,
                        )}`,
                        '_blank',
                      )
                    }}
                  >
                    {isEmpty(currentSelectedChild)
                      ? tipJarModalConfig.name
                      : currentSelectedChild.name}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default TipJarModal
